import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { Button, Modal, ModalCloseButton, ModalDescription, ModalFooter, ModalHeader } from '@tryhackme/thm-ui-components';
import { StyledFontAwesomeErrorIcon } from 'src/features/admin/manage-users/modals/modals.styles';
import type { DeleteUserModalProps } from '../../corporate.types';
import { StyledModalTitle } from '../add-seat-modal/add-seat-modal.styles';
export const DeleteUserModal = ({
  isModalOpen,
  isLoading,
  title,
  description,
  deleteButtonText,
  onModalOpen,
  onDeleteUser
}: DeleteUserModalProps) => <Modal open={isModalOpen} onOpenChange={open => onModalOpen(open)} preventOnOpenAutoFocus isSmall data-sentry-element="Modal" data-sentry-component="DeleteUserModal" data-sentry-source-file="delete-user-modal.tsx">
    <ModalHeader isSmall data-sentry-element="ModalHeader" data-sentry-source-file="delete-user-modal.tsx">
      <StyledModalTitle isSmall data-sentry-element="StyledModalTitle" data-sentry-source-file="delete-user-modal.tsx">
        <StyledFontAwesomeErrorIcon icon={faCircleExclamation} data-sentry-element="StyledFontAwesomeErrorIcon" data-sentry-source-file="delete-user-modal.tsx" />
        {title}
      </StyledModalTitle>
    </ModalHeader>
    <ModalDescription data-sentry-element="ModalDescription" data-sentry-source-file="delete-user-modal.tsx">{description}</ModalDescription>
    <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="delete-user-modal.tsx">
      <ModalCloseButton text="Close" data-sentry-element="ModalCloseButton" data-sentry-source-file="delete-user-modal.tsx" />
      <Button color="error" variant="solid"
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onClick={async () => {
      await onDeleteUser();
      onModalOpen(false);
    }} disabled={isLoading} isLoading={isLoading} data-sentry-element="Button" data-sentry-source-file="delete-user-modal.tsx">
        {deleteButtonText}
      </Button>
    </ModalFooter>
  </Modal>;